module.exports = __webpack_public_path__ + "img/facilityInfo_3_4.eaa40847.jpg";